import { useEffect, useRef } from "react";
import { BuzerIcon } from "../../BuzerIcons";
import "./prehlad-switch.css";

// v32.16 — Prehľad: prepínač sekcií ako rad piluliek s ikonou + názvom (podľa mocku).
// Aktívna je vyplnená farbou témy, ostatné biele s okrajom; rad sa dá scrollovať
// do strany. sections = [{ key, label, icon }].
export function PrehladSwitch({ sections = [], value, onChange }) {
  const listRef = useRef(null);
  const activeRef = useRef(null);
  // Pri zmene sekcie (klik aj swipe) doscrolluj aktívnu pilulku do stredu radu — nech je
  // pri prepnutí naspäť na „Štatistiky" vidno jej tlačidlo a pri „Odznakoch" vykukne
  // nasledujúca položka vpravo. block:nearest by inak scrolloval aj celý modal, preto
  // scrollujeme len horizontálne priamo kontajner.
  useEffect(() => {
    const c = listRef.current, el = activeRef.current;
    if (!c || !el) return;
    const target = el.offsetLeft - (c.clientWidth - el.offsetWidth) / 2;
    c.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
  }, [value]);
  return (
    <div ref={listRef} className="bz-secsw2" role="tablist" aria-label="Sekcie prehľadu">
      {sections.map((sec) => {
        const on = value === sec.key;
        return (
          <button
            key={sec.key}
            ref={on ? activeRef : undefined}
            type="button"
            role="tab"
            aria-selected={on}
            className={`bz-secsw2__pill${on ? " bz-secsw2__pill--on" : ""}`}
            onClick={() => onChange && onChange(sec.key)}
          >
            <BuzerIcon name={sec.icon || "chart"} size={16} color="currentColor" />
            {sec.label}
          </button>
        );
      })}
    </div>
  );
}
